<template>
    <!-- 订舱模板管理 -->
  <div class="page-container" id="templateManagement">
    <el-form
      ref="form"
      class="form-panel"
      label-position="top"
      :rules="searchDataFormRule"
             :model="searchData"
    >
      <el-row class="content-panel">
        <!-- 查询-start -->
        <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item label="模板名称:">
            <el-associate style="width: 100%;"
                          :columns="associate_columns_ebOrderTemplate"
                          :query-method="associate_queryMethod_ebOrderTemplate"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="templateName"
                          value-prop="templateName"
                          v-model="searchData.templateName"
                          :title="searchData.templateName"
                          placeholder=""
                          size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="船公司:">
            <el-associate style="width: 100%;"
                          :columns="associate_columns_carrier"
                          :query-method="associate_queryMethod_carrier"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="custNameCn"
                          value-prop="custAlias"
                          placeholder=""
                          v-model="searchData.carrierName"
                          size="mini"
            />
          </el-form-item>
        </el-col>
          <el-col :span="5">
            <el-form-item label="创建日期从:" prop="startTime">
              <el-date-picker
                v-model="searchData.startTime"
                align="right"
                type="date"
                style="width:100%;"
                size="mini"
                placeholder=""
                valueFormat="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="创建日期到:" prop="endTime">
              <el-date-picker
                v-model="searchData.endTime"
                align="right"
                type="date"
                style="width:100%;"
                size="mini"
                placeholder=""
                valueFormat="yyyy-MM-dd 23:59:59"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="模板有效性:">
              <el-select
                style="width:100%;"
                v-model="searchData.isActive"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in isActiveOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row gutter="20">
          <div style="text-align: right">
            <el-button type="primary" size="small" plain @click="queryForm">查询</el-button>
            <el-button align="right" type="info" size="small" plain @click="resetForm">重置</el-button>
          </div>
        </el-row>
      </el-row>
      <!-- 查询-end -->
    </el-form>
    <!-- 按钮栏-start -->
    <el-row style="margin-top: 15px">
      <el-button type="info" size="small" plain @click="ebOrderTemplateOn">启用</el-button>
      <el-button type="info" size="small" plain @click="ebOrderTemplateOff">禁用</el-button>
      <el-button type="info" size="small" plain @click="ebOrderTemplateExcel">导出Excel</el-button>
      <!-- 按钮栏-end -->
    </el-row>
    <!-- 表格-start -->
    <el-row style="margin-top: 15px">
      <hot-table
        ref="ebOrderTemplateTableRef"
        :data-source="ebOrderTemplateDataSource"
        :settings="tableSettings"
        @cellDblclick="tableCellClick"
        @rowDblclick="tableRowClick"
      >
        <hot-column :has-tip="true" data="ebOrderTemplateId" title="操作" width="120">
          <column-edit-renderer hot-renderer @clickModule="clickModule" />
        </hot-column>
        <hot-column :has-tip="true" data="isActive" title="状态" width="150" dictName="EB_ORDER_TEMPLATENAME_ISACTIVE"/>
        <hot-column :has-tip="true" data="templateName" title="模板名称" width="150"/>
        <hot-column :has-tip="true" data="carrierName" title="船公司" width="150"/>
        <hot-column :has-tip="true" data="creatorName" title="创建人" width="150"/>
        <hot-column :has-tip="true" data="createTime" date-format="YYYY-MM-DD HH:mm:ss" title="创建时间" width="150" />
        <hot-column :has-tip="true" data="lastModifierName" title="修改人" width="150" />\
        <hot-column :has-tip="true" data="lastModifyTime" date-format="yyyy-MM-DD HH:mm:ss" title="修改时间" width="150" />
      </hot-table>
      <!-- 分页start -->
      <!-- 分页start -->
      <div class="pg_div">
        <el-pagination
          :current-page="pageConfig.currentPage"
          :layout="pageConfig.layout"
          :page-size="pageConfig.pageSize"
          :page-sizes="pageConfig.pageSizes"
          :total="pageConfig.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
      <!-- 分页end -->
    </el-row>
  </div>
</template>

<script>
  import { queryCarrierInfo, queryDictRows } from "@/api/commonService";
import ResizeObserver from "resize-observer-polyfill";
import ebOrderTemplate from "@/api/ebOrderTemplate";
import columnEditRenderer from "@/components/CustomRenderer/columnEditRenderer";
export default {
  components: {
    columnEditRenderer,
  },
  inject: ['reload'],
  data() {
    return {
      searchData: {
        carrierName: null,
        templateName: null,
        startTime: null,
        endTime: null,
        isActive: 1
      },
      searchDataFormRule: {
         startTime: [
           { validator: (rule, value, callback) => {
             const searchData = this.searchData
             if (searchData.startTime && searchData.endTime &&
               searchData.endTime < searchData.startTime) {
               callback(new Error('开始时间不能大于结束时间'));
             }
             callback()
             }, trigger: 'blur' }
         ],
        endTime: [
          { validator: (rule, value, callback) => {
              const searchData = this.searchData
              if (searchData.startTime && searchData.endTime) {
                const startTime = new Date(searchData.startTime)
                const endTime = new Date(searchData.endTime)
                if (endTime.getTime() <= startTime.getTime()) {
                  callback(new Error('开始时间不能大于结束时间'));
                }
              }
              callback()
            }, trigger: 'blur' }
        ],
      },
      currentRow: {

      },
      ebOrderTemplateDataSource: [
        {
          ebOrderTemplateId: 1,
          isActive: 1,
          templateName: 1,
          carrierName: 1,
          creatorName: 1,
          createTime: '2021.1.1',
          lastModifierName: 1,
          lastModifyTime: '2021.1.1'
        }
      ],
      isActiveOptions: [
        {
          value: '有效',
          key: 1
        },
        {
          value: '无效',
          key: 0
        },
        {
          value: 'All',
          key: 2
        }
      ],
      // 表格设置
      tableSettings: {
        height: 320,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig
      },
      // 分页
      pageConfig: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 10,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },
      // 船公司联想控件
      associate_columns_carrier: [
        {
          title: "中文简称",
          field: 'custAlias'
        },
        {
          title: "中文全称",
          field: 'custNameCn'
        },
        {
          title: "助记码",
          field: 'mnemonicCode'
        }
      ],
      // 模板名称联想控件
      associate_columns_ebOrderTemplate: [
        {
          title: "模板名称",
          field: 'templateName'
        }
      ],
      //日期设置
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      shortcuts: [{
        text: '今天',
        onClick(picker) {
          picker.$emit('pick', new Date());
        }
      }, {
        text: '昨天',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          picker.$emit('pick', date);
        }
      }, {
        text: '一周前',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        }
      }]
    };
  },
  async created() {
    this.getSelectList();

  },
  mounted() {
    let self = this
    // self.queryForm()
    self.queryEbOrderTemplateIsActive()
    // 监听外层容器div宽度的变化，做表格自适应
    self.resizeObserver = new ResizeObserver(entries => {
      self.$nextTick(() => {
        self.$refs.tableRef.resizeTo(entries[0].target.clientWidth - 32)
      })
    })
    self.resizeObserver.observe(document.getElementById("templateManagement"))
  },
  beforeDestroy() {
    let _this = this
    // 离开页面删除检测器和所有侦听器
    _this.resizeObserver.disconnect();
  },
  methods: {
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {}
      if (keyword === '') {
        params = {
          custType4: "%SO%",
          isDeleted6: "0"
        }
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        }
      }
      let data =
        {
          action: "query",
          crudType: "SELECT",
          sorting: ["CTS_ILPCsCust.custNameCn"],
          mainModelName: "CTS_ILPCsCust",
          tag: "CTS_WEB_es",
          where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
          currentPage: currentPage,
          pageSize: pageSize,
          returnPage: true,
          returnTotal: false,
          reqArgs: params,
          fields: [
            "CTS_ILPCsCust.csCustId",
            "CTS_ILPCsCust.custAlias",
            "CTS_ILPCsCust.custNameCn",
            "CTS_ILPCsCust.custNameEn",
            "CTS_ILPCsCust.customsRegisteredNo",
            "CTS_ILPCsCust.esCustType",
            "CTS_ILPCsCust.isActive",
            "CTS_ILPCsCust.isBlacklist",
            "CTS_ILPCsCust.isCustomer",
            "CTS_ILPCsCust.isDeleted",
            "CTS_ILPCsCust.isOneTimeCustomer",
            "CTS_ILPCsCust.isSettlement",
            "CTS_ILPCsCust.isSupplier",
            "CTS_ILPCsCust.legalPerson",
            "CTS_ILPCsCust.mdmCustCode",
            "CTS_ILPCsCust.mobileNo",
            "CTS_ILPCsCust.postCode"
          ],
          enableCascade: true
        }
      return new Promise(resolve => {
        queryCarrierInfo(data).then(res => {
          console.log("queryCarrierInfo", res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 模板名称联想控件数据源
    associate_queryMethod_ebOrderTemplate({ keyword, pageSize, currentPage }) {
      let params = {}
      params.templateName = keyword
      params.page = currentPage
      params.limit = pageSize
      return new Promise(resolve => {
        ebOrderTemplate.queryEbOrderTemplateName(params).then(res => {
          console.log(res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 重置
    resetForm() {
      this.searchData = {
        carrierName: null,
        templateName: null,
        startTime: null,
        endTime: null,
        isActive: 1
      }
    },
    //启用
    ebOrderTemplateOn() {
      const selections = this.$refs.ebOrderTemplateTableRef.getSelections()
      let flags = false
      let ebOrderTemplates = []
      console.log('getSelected',this.$refs.ebOrderTemplateTableRef.getSelections())
      if (selections.length > 0) {
        for (const item of selections) {
          if (item.isActive) {
            flags = true
            this.$coreMethods.message('warning','请选择无效的记录。')
            return
          }
          ebOrderTemplates.push({
            ebOrderTemplateId: item.ebOrderTemplateId,
            isActive: 1
          })
        }
        ebOrderTemplate.ebOrderTemplateOnOff(ebOrderTemplates).then(res => {
          if (res.success) {
            this.$coreMethods.message('success','操作成功')
            this.reload()
          }
        })
      } else {
        this.$coreMethods.message('warning','请勾选记录')
      }
    },
    //禁用
    ebOrderTemplateOff() {
      const selections = this.$refs.ebOrderTemplateTableRef.getSelections()
      let flags = false
      let ebOrderTemplates = []
      console.log('getSelected',this.$refs.ebOrderTemplateTableRef.getSelections())
      if (selections.length > 0) {
        for (const item of selections) {
          if (!item.isActive) {
            flags = true
            this.$coreMethods.message('warning','请选择有效的记录。')
            return
          }
          ebOrderTemplates.push({
            ebOrderTemplateId: item.ebOrderTemplateId,
            isActive: 0
          })
        }
        ebOrderTemplate.ebOrderTemplateOnOff(ebOrderTemplates).then(res => {
          if (res.success) {
            this.$coreMethods.message('success','操作成功')
            this.reload()
          }
        })
      } else {
        this.$coreMethods.message('warning','请勾选记录')
      }
    },
    //过滤对象空值
    filterEmpty(searchData) {
      for (const key in searchData) {
        if (!searchData[key] && searchData[key] !== 0){
          delete searchData[key]
        }
      }
    },
    //导出Excel
    ebOrderTemplateExcel() {
      let searchData = {
        ...this.searchData,
        page: this.pageConfig.currentPage,
        limit: this.pageConfig.pageSize,
      }
      this.filterEmpty(searchData)
      ebOrderTemplate.ebOrderTemplateExcel(searchData)
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageConfig.pageSize = val
      this.queryForm()
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val
      this.queryForm()
    },
    tableCellClick(value) {
    },
    tableRowClick(value) {
      this.currentRow = value.record
      console.log('tableRowClick')
    },
    //点击
    clickModule(e) {
      const currentRow = this.currentRow
      console.log('currentRow',currentRow)
      if (currentRow.isActive) {
        this.$router.push({
          name: 'bookingAdd',
          params: {
            ebOrderTemplateId: currentRow.jsonInfo
          }
        })
      } else {
        this.$coreMethods.message('warning','请选择有效的记录。')
      }
    },
    //简单查询
    queryForm() {
      let searchData = {
        ...this.searchData,
        page: this.pageConfig.currentPage,
        limit: this.pageConfig.pageSize,
      }
      this.filterEmpty(searchData)
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log(searchData)
          ebOrderTemplate.queryEbOrderTemplate(searchData).then(res => {
            if (res.success) {
              const data = res.data.data
              for (const value of data) {
                value.isActive = value.isActive? 1 : 0
              }
              this.ebOrderTemplateDataSource = data
              this.pageConfig.total = res.data.totalRecord
            }
          })
        }
      })
    },
    // 获取数据字典
    getSelectList() {
      queryDictRows('MD_CODE_DICT$MD_CODE_YESNO').then(res => {
        /*name:value value:key*/
        console.log("queryDictRows:", res)
        //模板状态
        this.isActiveOptions = res.MD_CODE_DICT$MD_CODE_YESNO
        this.isActiveOptions.forEach(value => {
          value.key = value.key === '1'? 1 : 0
        })
        this.queryEbOrderTemplateIsActive()
      })
    },
    //模板状态数据字典
    queryEbOrderTemplateIsActive() {
      let dict = []
      this.isActiveOptions.forEach(item => {
        let param = {}
        param.name = item.value
        param.value = item.key
        dict.push(param)
      })
      console.log("isActiveList", dict)
      // 数据字典
      this.$hotTableUtils.registDict({ 'EB_ORDER_TEMPLATENAME_ISACTIVE': dict })
    },
  }
};
</script>

<style scoped lang="less">

</style>
